const Config = {
	BASE_URL: "https://jogastar.mydevnxerra.com/",
	EXTENDED_URL: "api/v1/"
}
export default Config